<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ title }}</h3>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <input
          *ngIf="!multiline"
          type="text"
          [(ngModel)]="localValue"
          [placeholder]="placeholder"
          class="text-input"
        />
        <textarea
          #textInput
          *ngIf="multiline"
          [(ngModel)]="localValue"
          [placeholder]="placeholder"
          [rows]="rows"
          class="text-input"
          (keyup)="onKeyup($event)"
        ></textarea>
        <div style="font-size: 11px; font-style: italic">
          Newline -> Shift + Enter
        </div>
      </div>
      <div
        class="form-row"
        style="margin-top: 10px; gap: 8px; align-items: center"
      >
        <label style="min-width: 90px">Font size</label>
        <input
          type="number"
          [(ngModel)]="localFontSize"
          class="text-input"
          style="width: 120px"
        />
      </div>
      <div
        class="form-row"
        style="margin-top: 8px; gap: 8px; align-items: center"
      >
        <label style="min-width: 90px">Width ratio</label>
        <input
          type="number"
          step="0.01"
          min="0"
          max="1"
          [(ngModel)]="localWidthRatio"
          class="text-input"
          style="width: 120px"
        />
      </div>
      <div
        class="form-row"
        style="margin-top: 8px; gap: 8px; align-items: center"
      >
        <label style="min-width: 90px">Font align</label>
        <div style="display: flex; gap: 8px; align-items: center">
          <nw-icon
            type="format_align_left"
            color="black"
            [outlined]="localFontAlign !== 'left'"
            (click)="setFontAlign('left')"
          ></nw-icon>
          <nw-icon
            type="format_align_center"
            color="black"
            [outlined]="localFontAlign !== 'center'"
            (click)="setFontAlign('center')"
          ></nw-icon>
          <nw-icon
            type="format_align_right"
            color="black"
            [outlined]="localFontAlign !== 'right'"
            (click)="setFontAlign('right')"
          ></nw-icon>
          <nw-icon
            type="format_align_justify"
            color="black"
            [outlined]="localFontAlign !== 'justify'"
            (click)="setFontAlign('justify')"
          ></nw-icon>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="secondary" (click)="onClose()">Cancel</button>
      <button class="primary" (click)="onSave()">Save</button>
    </div>
  </div>
</div>
